// Central brand & business content. Update here to change everywhere.
export const BRAND = {
    name: "Wappit",
    domain: "wappit.app",
    url: "https://wappit.app",
    tagline: "Official WhatsApp Business API Provider for Growing Businesses",
    whatsapp: {
        number: "+919289505505",
        display: "+91 9289 505 505",
        waLink: "https://wa.me/919289505505?text=Hi%20Wappit%20team%2C%20I%27d%20like%20to%20know%20more%20about%20your%20WhatsApp%20Business%20API",
    },
    support: {
        hours: "9 AM – 7 PM",
    },
    trust: {
        clients: "900+",
        messages: "7+ Crore",
        activeBusinesses: "122+",
        experience: "13+ Years",
    },
    links: {
        login: "https://wp.promotionkart.com/",
        bookDemo: "https://calendly.com/promotionkart/whatsapp-business-api-1",
    },
    address: {
        line1: "FF-10, Pearl Omaxe Tower",
        line2: "Netaji Subhash Palace, Pitampura",
        line3: "New Delhi – 110034, India",
    },
};